"use strict";
/*
 * Created on Fri Jul 20 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>
 *     Description of price list header, which includes primarily information about price list priority and group of sites.
 *     The core output of P&P applications is reflected within price lists (and price list rows).
 * </p>
 *
 * @see {@link PriceListRow}
 *
 * @author RV
 * @author VRu
 */


var PriceList =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PriceList, _DomainObject_1$Domai);

  /**
   * Constructs price list instance.
   *
   * @param id
   * @param externalId
   * @param name name of price list
   * @param priority
   * @param priceListTypeId PriceListType codebook id
   * @param groupOfSiteId
   * @param processed defines whether an instance was processed (used primarily for import)
   */
  function PriceList(id, externalId, name, priority, priceListTypeId, groupOfSiteId, processed) {
    var _this;

    _classCallCheck(this, PriceList);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PriceList).call(this));
    _this.id = id;
    _this.externalId = externalId;
    _this.name = name;
    _this.priority = priority;
    _this.priceListTypeId = priceListTypeId;
    _this.groupOfSiteId = groupOfSiteId;
    _this.processed = processed;
    return _this;
  }

  return PriceList;
}(DomainObject_1.DomainObject);

exports.PriceList = PriceList;

PriceList.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PriceList.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    name: builder.str('name'),
    priority: builder.num('priority'),
    priceListTypeId: builder.str('priceListTypeId'),
    groupOfSiteId: builder.str('groupOfSiteId'),
    processed: builder.bool('processed')
  };
}();